import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useCurrentSubscription } from '@/hooks/useCurrentSubscription';

interface SubscriptionGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
  allowBillingPage?: boolean; // Allow access to billing page even without subscription
  allowedUserTypes?: string[]; // Allow only specific user types (e.g., ['regular'] to exclude 'shopify_store')
}

export function SubscriptionGuard({ 
  children, 
  redirectTo = '/home/billing',
  allowBillingPage = true,
  allowedUserTypes
}: SubscriptionGuardProps) {
  const location = useLocation();

  const isBillingPage = location.pathname === redirectTo || 
                        location.pathname === '/home/billing' ||
                        location.pathname.startsWith('/home/billing');

  const { data: subscription, isLoading } = useCurrentSubscription();

  if (!isLoading && allowedUserTypes && subscription) {
    const userType = subscription.user_type || 'regular';
    
    if (!allowedUserTypes.includes(userType)) {
      return <Navigate to="/home" replace />;
    }
  }


  return <>{children}</>;
}

